const getDisplayedQuantity = ({
    quantity,
    maxDisplayedQuantity,
    desiredQuantity,
}: {
    quantity: number;
    maxDisplayedQuantity: number;
    desiredQuantity: number;
}) => {
    if (quantity <= maxDisplayedQuantity) {
        return quantity;
    }

    if (desiredQuantity <= maxDisplayedQuantity) {
        return `${maxDisplayedQuantity}+`;
    }

    return Math.min(quantity, desiredQuantity);
};

export default getDisplayedQuantity;
